import React from 'react'
import { BiSolidMap } from 'react-icons/bi'

const LocationIcon = () => {
  return (
    <BiSolidMap
      className="text-yellow-500 h-8 w-8"
      aria-label="location icon"
    />
  )
}

export default LocationIcon
